import React, {
  useRef,
  useMemo,
  useState,
  useCallback,
  ReactNode,
} from "react";
import { withRouter } from "react-router-dom";

import {
  ActionToolbar,
  CommunicationDetails,
  DialogWithActions,
  EditButton,
  GqlTable,
} from "../../components";

import { Button, Container } from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";

import { QUERIES } from "../../../graphql";
import { Communication, CommunicationData } from "../../../graphql/models";
import { CommunicationForm } from "./communications_form";

import useCommunicationsStyle from "./communications.style";
//import { useUserState } from '../../../context';

function CommunicationsPage(props: any) {
  const classes = useCommunicationsStyle();

  const tableRef = useRef();

  //const { userRole } = useUserState();
  const [formDialogOpened, setFormDialogOpened] = useState(false);
  const [formCommunication, setFormCommunication] = useState<
    Communication | CommunicationData | undefined
  >(void 0);

  const addNewCommunication = () => {
    setFormCommunication({} as Communication);
    setFormDialogOpened(true);
  };

  const editCommunication = (row) => {
    setFormCommunication({
      ...row,
    });
    setFormDialogOpened(true);
  };

  const onValueUpdatedSuccessfully = () => {
    setFormCommunication(void 0);
    setFormDialogOpened(false);
    (tableRef as any).current?.refresh();
  };

  const gqlTableRowActions = useCallback((row: Communication) => {
    const actions: ReactNode[] = [];
    actions.push(
      <EditButton
        key="editCommunication"
        onClick={() => editCommunication(row)}
      />
    );

    if (!row.draft) {
      actions.push(
        <CommunicationDetails
          key="CommunicationDetails"
          communicationId={row.id}
        />
      );
    }

    return actions;
  }, []);

  const actionToolbarActions = useMemo(() => {
    const actions: any[] = [];
    actions.push(
      <Button
        key="addNewCommunication"
        variant="contained"
        color="primary"
        onClick={() => addNewCommunication()}
      >
        Aggiungi Nuovo
      </Button>
    );

    return actions;
  }, []);

  return (
    <Container className={classes.container} maxWidth={false} component="div">
      <>
        <ActionToolbar title={"Comunicazioni"} actions={actionToolbarActions} />
        <GqlTable
          ref={tableRef}
          columns={[
            "",
            "Bozza?",
            "Nome",
            "Oggetto",
            "Gruppi",
            "Tot. Destinatari",
          ].map((v, index) => (
            <TableCell key={index}>{v}</TableCell>
          ))}
          query={QUERIES.COMMUNICATIONS}
          queryResultDataField="communications"
          rows={(row) => (
            <>
              <TableCell>{gqlTableRowActions(row)}</TableCell>
              <TableCell>{row.draft ? "Sì" : "No"}</TableCell>
              <TableCell>{row.name}</TableCell>
              <TableCell>{row.subject}</TableCell>
              <TableCell>{row.groups.map((g) => g.name).join(", ")}</TableCell>
              <TableCell>{row.targets.length}</TableCell>
            </>
          )}
        />
        <DialogWithActions
          fullScreen
          open={formDialogOpened}
          setOpen={setFormDialogOpened}
          title={"Aggiungi / Modifica Comunicazione"}
        >
          <CommunicationForm
            value={formCommunication}
            onValueUpdatedSuccessfully={onValueUpdatedSuccessfully}
          />
        </DialogWithActions>
      </>
    </Container>
  );
}

export default withRouter(CommunicationsPage);
